import { StarOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { Grey5 } from "styles/antTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

interface IStarEmptyIconProps {
    color?: string;
}

type Props = IBTIconProps & IStarEmptyIconProps;

export const BTIconStarEmptyOutlined: FunctionComponent<Props> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return (
        <StarOutlined
            {...props}
            type="star"
            style={{ ...props.style, color: baseProps.color ?? Grey5 }}
        />
    );
};
